import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 409,
  name: 'Conflict',
  description:
    'The request conflicts with the current state of the target resource. The server cannot complete the request because it would create an inconsistency — such as a duplicate record or a version mismatch.',
  causes: [
    'Attempting to create a resource that already exists, e.g., registering a username or email that is already taken.',
    'Optimistic concurrency conflict — two users edited the same record simultaneously and the second save conflicts with the first.',
    'A state transition that is not allowed, e.g., trying to publish a document that is already published or cancelling an order that has already shipped.',
  ],
  fixes: [
    'Read the response body for details about the conflict. Most APIs explain which field or constraint was violated.',
    'For concurrency conflicts, fetch the latest version of the resource, merge changes, and retry the request.',
    'For duplicate-key conflicts, check if the resource already exists before creating it, or use an upsert operation if your API supports it.',
  ],
  monitoringTip:
    'A sudden spike in 409 errors may indicate a race condition or broken deduplication logic in your application. Uptrack alerts you to status code changes so you can investigate before data integrity issues escalate.',
}

export const Route = createFileRoute('/_site/http/409')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
